import React from 'react';
import {Modal} from 'antd';

export default function ArchiX6ViewPickerModal({open, items, onSelect, onCancel}) {
	return (
		<Modal
			title="Выберите диаграмму"
			open={open}
			onCancel={onCancel}
			footer={null}
			destroyOnHidden
		>
			<div style={{display: 'flex', flexDirection: 'column', gap: 4, marginTop: 8}}>
				{items.map(({viewId, viewName}) => (
					<button
						key={viewId}
						type="button"
						onClick={() => onSelect?.(viewId)}
						style={{
							padding: '8px 12px',
							textAlign: 'left',
							border: '1px solid #d9d9d9',
							borderRadius: 6,
							background: '#fff',
							cursor: 'pointer',
						}}
					>
						{viewName || viewId}
					</button>
				))}
			</div>
		</Modal>
	);
}
